const ROLE_MANAGER = 'director'
const ROLE_ADV = 'adv'
const ROLE_DIRECTOR = 'director'

const ORG_VIETNAM = "vn";
const ORG_VIETNAM2 = "vn2";
const ORG_VIETNAM3 = "vn3";
const ORG_VIETNAM4 = "vn4";
const ORG_VIETNAMID = "vnid";
const ORG_INDONESIA = "id";
const ORG_INDONESIA2 = "id2";
const ORG_INDONESIA3 = "id3";
const ORG_THAILAND = "th";
const ORG_THAILAND1 = "th1";
const ORG_THAILAND2 = "th2";
const ORG_THAILAND4 = "th4";
const ORG_MALAYSIA = "my";
const ORG_MALAYSIA2 = "my2";
const ORG_PHILIPPINES = "ph";
const ORG_INDIA1 = "in1";
const ORG_PERU = "pe1";
const ORG_COLOMBIA = "co1";
const ORG_IDH = "idh";
const ORG_MALAYSIA3 = "my3";

// Gom theo quốc gia; index khớp LOGIN_DOMAIN_MAPPING (DomainConfig.js)
const ORG_ALL = [
    ORG_THAILAND,      // 0
    ORG_THAILAND1,     // 1
    ORG_THAILAND2,     // 2
    ORG_THAILAND4,     // 3
    ORG_INDONESIA,     // 4  id
    ORG_INDONESIA2,    // 5  id2
    ORG_INDONESIA3,    // 6  id3
    ORG_IDH,           // 7  id4
    ORG_VIETNAM,       // 8
    ORG_VIETNAM2,      // 9
    ORG_VIETNAM3,      // 10
    ORG_VIETNAM4,      // 11
    ORG_VIETNAMID,     // 12
    ORG_MALAYSIA,      // 13
    ORG_MALAYSIA2,     // 14
    ORG_MALAYSIA3,     // 15
    ORG_PHILIPPINES,   // 16
    ORG_INDIA1,        // 17
    ORG_PERU,          // 18
    ORG_COLOMBIA,      // 19
];
const SIZE_L = "L";
const SIZE_M = "M";
const SIZE_X = "X";

export {
    ROLE_MANAGER,
    ROLE_ADV,
    ROLE_DIRECTOR,
    ORG_VIETNAM,
    ORG_VIETNAM2,
    ORG_VIETNAM3,
    ORG_VIETNAM4,
    ORG_VIETNAMID,
    ORG_INDONESIA,
    ORG_INDONESIA2,
    ORG_INDONESIA3,
    ORG_THAILAND,
    ORG_THAILAND1,
    ORG_THAILAND2,
    ORG_THAILAND4,
    ORG_MALAYSIA,
    ORG_MALAYSIA2,
    ORG_PHILIPPINES,
    ORG_INDIA1,
    ORG_PERU,
    ORG_COLOMBIA,
    ORG_IDH,
    ORG_ALL,
    SIZE_L,
    SIZE_M,
    SIZE_X
};